import { Box, Button, CssBaseline, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useContext, useEffect, useRef, useState } from 'react'
import TwoHeadTable from '../../../../../../components/TwoHeadTable'
import EnergyReportingLogTable from '../../../../../../components/charts/energy_reporting/EnergyReportingLogTable'
import { InverterContext } from '../../../../../../context/InverterContext'
import Pagination from '../../../../../../components/general/Pagination'
import ExportContent from '../../../../../../components/ExportContent'
import AutorenewIcon from '@mui/icons-material/Autorenew';
import { getDateTimeForDashboardTab1, getFromTo } from '../../../../../../utils'
import generatePDF from 'react-to-pdf'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
let TableHeading
function DailyEnergyLogs() {
    const { InverterChartData, getInverterChartData } = useContext(InverterContext)

    const [StartDate, setStartDate] = useState(getDateTimeForDashboardTab1().LastDay)
    const [EndDate, setEndDate] = useState(getDateTimeForDashboardTab1().Today)
    
    const LCODE = sessionStorage.getItem('LCODE')

    if (InverterChartData?.length > 0) {
        const data = InverterChartData[0]
        TableHeading = Object.keys(data)
    }
    useEffect(() => {
        getInverterChartData(LCODE, StartDate, EndDate)
    }, [])


    function onRefreshData() {
        if (StartDate.length !== 0 && EndDate.length !== 0) {
            getInverterChartData(LCODE, StartDate, EndDate)
        } else {
            alert('please provide any date')
        }

    }

    // console.log("startDate",StartDate.Months)

    return (
        <EnergyReportingLogTable
            onRefreshData={onRefreshData}
            TableData={InverterChartData}
            TableHead={TableHeading}
            ValueOf1={StartDate}
            ValueOf2={EndDate}
            onChangeValueOF1={(val) => setStartDate(val.target.value)}
            onChangeValueOF2={(val) => setEndDate(val.target.value)}
            radiationName={'Daily Energy Log'}
        />

    )
}

export default DailyEnergyLogs


